export const UI_VERSION = 'v7.10.0'
export const SYSTEM_VERSION = 'v8.3.0'
// export const SYSTEM_VERSION = 'v7.0.0'
// export const UI_VERSION = 'v7.2.2's